// -- Push Notification Service (Client-Side) ---------------------------------
// Registriert das Device fuer Remote-Push via APNs und synct die Watchlist

import { PushNotifications } from '@capacitor/push-notifications';
import { PROXY_BASE, isNative } from '../config/apiConfig';
import { getAuthHeaders } from './authService';

const DEVICE_TOKEN_KEY = 'bullivo_push_token';
let registered = false;

export async function getPushPermissionStatus() {
  if (!isNative()) {
    if (!('Notification' in window)) return 'not-supported';
    return Notification.permission === 'default' ? 'prompt' : Notification.permission;
  }

  try {
    const perm = await PushNotifications.checkPermissions();
    return perm.receive;
  } catch (err) {
    console.error('[PUSH] Permission-Status Fehler:', err);
    return 'denied';
  }
}

export async function requestPushPermission() {
  if (!isNative()) {
    if (!('Notification' in window)) return false;
    if (Notification.permission === 'granted') return true;
    if (Notification.permission === 'denied') return false;
    return (await Notification.requestPermission()) === 'granted';
  }

  try {
    const current = await PushNotifications.checkPermissions();
    if (current.receive === 'granted') return true;
    if (current.receive === 'denied') return false;
    const requested = await PushNotifications.requestPermissions();
    return requested.receive === 'granted';
  } catch (err) {
    console.error('[PUSH] Permission-Request Fehler:', err);
    return false;
  }
}

// Push-Berechtigung anfragen und Token registrieren
export async function initPush() {
  if (!isNative()) return null;

  try {
    const granted = await requestPushPermission();
    if (!granted) return null;

    if (!registered) {
      PushNotifications.addListener('registration', async (token) => {
        console.log('[PUSH] Token erhalten:', token.value.slice(0, 16) + '…');
        localStorage.setItem(DEVICE_TOKEN_KEY, token.value);
        await registerWithServer(token.value);
      });

      PushNotifications.addListener('registrationError', (err) => {
        console.error('[PUSH] Registrierung fehlgeschlagen:', err);
      });

      PushNotifications.addListener('pushNotificationReceived', (notification) => {
        console.log('[PUSH] Notification empfangen:', notification);
      });

      PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
        console.log('[PUSH] Action:', action);
        const ticker = action.notification?.data?.ticker;
        const type = action.notification?.data?.type;
        window.dispatchEvent(new CustomEvent('push-navigate', { detail: { ticker, type } }));
      });

      registered = true;
    }

    await PushNotifications.register();
    return localStorage.getItem(DEVICE_TOKEN_KEY);
  } catch (err) {
    console.error('[PUSH] Init Fehler:', err);
    return null;
  }
}

async function registerWithServer(deviceToken) {
  try {
    await fetch(`${PROXY_BASE}/api/register-device`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...await getAuthHeaders() },
      body: JSON.stringify({ deviceToken }),
    });
  } catch (err) {
    console.error('[PUSH] Server-Registrierung fehlgeschlagen:', err);
  }
}

export async function syncWatchlistWithServer(watchlist, alertsEnabled = true, notifPrefs = null) {
  const deviceToken = localStorage.getItem(DEVICE_TOKEN_KEY);
  if (!deviceToken) return;

  const body = {
    deviceToken,
    watchlist: watchlist.map((a) => a.ticker || a),
    alertsEnabled,
  };

  if (notifPrefs) body.notifPrefs = notifPrefs;

  try {
    await fetch(`${PROXY_BASE}/api/sync-watchlist`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...await getAuthHeaders() },
      body: JSON.stringify(body),
    });
  } catch (err) {
    console.error('[PUSH] Watchlist-Sync fehlgeschlagen:', err);
  }
}

export function getDeviceToken() {
  return localStorage.getItem(DEVICE_TOKEN_KEY);
}
